import React from 'react';

const StepIndicator = ({ currentStep }) => {
    const steps = [1, 2, 3]; // Define the steps

    return (
        <div className="flex justify-center items-center md:gap-16 gap-8 py-10">
            {steps.map((step) => (
                <div
                    key={step}
                    className={`w-20 h-20 flex justify-center items-center rounded-full border-2 text-3xl
                    ${step === currentStep ? 'bg-[#A67FAA] border-[#A67FAA] text-white' : 'text-[#A67FAA] bg-white border-[#A67FAA]'}`}
                >
                    {step}
                </div>
            ))}
        </div>
    );
};

export default StepIndicator;
